module.exports = __webpack_public_path__ + "img/osho.06e9e833.png";